import React from 'react';

import { MailIcon } from './Icons';

export const EmailLink = ({ email, className }) => (
  <a
    css={`
      display: flex;

      ${className};
    `}
    href={`mailto:${email}`}
  >
    <MailIcon
      css={`
        color: initial;
      `}
    />
    {email}
  </a>
);



// WEBPACK FOOTER //
// ./app/components/EmailLink.js